import { AlertRuleList } from '../alerts/AlertRuleList';
import { useAircraft } from './AircraftDetailLayout';

export function AircraftAlertsTab() {
  const aircraft = useAircraft();
  return <AlertRuleList aircraftId={aircraft.id} />;
}
